/** Beets stS — `getRate()` returns 1e18-scaled S-per-stS,
 *  `totalPool()` returns the undelegated S buffer (used as
 *  instant-exit liquidity). */
export const BeetsStSAbi = [
  {
    name: 'getRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalPool',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
